//	L I B S

import { lib_api_shared } from '../libs/lib.api.shared';
import { lib_names } from '../libs/lib.names';
import { lib_names_shared } from '../libs/lib.names.shared';

//	T Y P E S

import { type___api___response } from '../types/types.api-response';
import { type___locale___language } from '../types/types.locale';
import { type___digitalmenu___currency, type___digitalmenu___dish_measurement_unit } from '../types/types.digitalmenu';
import { type___cookies___accepted } from '../types/types.cookies';
import { type___digitalmenu___theme } from '../types/types.theme';

//	E X P O R T

export class service_RestApiService {

//#region 																							D E C L A R A T I O N S

	private _HEADERS: any = { 'Content-Type': lib_api_shared.content_type };

//#endregion

//#region 																							L O A D   P R O P S

	private load_props___language() : void
	{
		const ___language: type___locale___language | null = localStorage.getItem(lib_names.localStorage.user___language) as type___locale___language | null ?? null;
		if (___language) { this._HEADERS[lib_api_shared.headers.extra___x_locale] = ___language as type___locale___language; }
	}

	private load_props___tracking() : void
	{
		const ___cookies___accepted: type___cookies___accepted | null = localStorage.getItem(lib_names.localStorage.user___cookies_accepted) as type___cookies___accepted | null ?? null;
		if (___cookies___accepted) { this._HEADERS[lib_api_shared.headers.extra___x_tracking] = ___cookies___accepted as type___cookies___accepted; }
	}

	private load_props___whoami() : void
	{
		const ___whoami_token: string | null = localStorage.getItem(lib_names.localStorage.user___logintoken) as string | null ?? null;
		if (___whoami_token) { this._HEADERS[lib_api_shared.headers.default___authorization] = lib_api_shared.headers.default___authorization___bearer + ' ' + ___whoami_token as string; }
	}

//#endregion

//#region 																							R E T U R N   S E R V E R   R E S P O N S E

	private async return_server_response(___action: string, ___target: string, ___to_post: any | {}, ___signal: AbortSignal | null = null) : Promise<type___api___response>
	{

		this.load_props___language();
		this.load_props___tracking();
		this.load_props___whoami();

	//	console.log('this._HEADERS',this._HEADERS)

		const ___s_route: string = lib_names_shared.endpoints.server_nearby + ___action + '/' + ___target;
		try {
			const ___s_response: Response = await fetch(___s_route, {
				method: 'POST',
				headers: this._HEADERS,
				body: JSON.stringify(___to_post),
				signal: ___signal
			});
			if (___s_response.ok) {
				try {
					const ___server_response: any = await ___s_response.json();
					return (___server_response !== null && ___server_response !== undefined) ? ___server_response : null;
				} catch (___e: any) {
					return { response: 'error', message: 'api-error', data: {} };
				}
			} else {
				return { response: 'error', message: 'api-error', data: {} };
			}
		} catch (___e_main: any) {
			console.error('Error fetching server response:', ___e_main);
			return { response: 'error', message: 'api-error', data: {} };
		}

	}

//#endregion

//#region 																							A U T H   P A S S W O R D   C H A N G E

	async auth___perform___password_change(___old_password: string | null, ___new_password: string) : Promise<type___api___response>
	{
		const ___to_post: any = { 'old_password': ___old_password, 'new_password': ___new_password };
		return await this.return_server_response('auth', 'password_change', ___to_post);
	}

//#endregion

//#region 																							A U T H   D E L E T E   A C C O U N T

	async auth_delete_account___delete_account(___password: string) : Promise<type___api___response>
	{
		const ___to_post: any = { 'password': ___password };
		return await this.return_server_response('auth_delete_account', 'delete', ___to_post);
	}

//#endregion

//#region 																							D I G I T A L M E N U S

	async digitalmenus___read_multi(___last_index: number = 0) : Promise<type___api___response>
	{
		const ___to_post: any = { 'last_index': ___last_index };
		return await this.return_server_response('digitalmenus', 'read_multi', ___to_post);
	}

	async digitalmenus___read_single(___m_id: string) : Promise<type___api___response>
	{
		const ___to_post: any = { 'm_id': ___m_id };
		return await this.return_server_response('digitalmenus', 'read_single', ___to_post);
	}

	async digitalmenu___set_theme(___m_id: string, ___theme: type___digitalmenu___theme) : Promise<type___api___response>
	{
		const ___to_post: any = { 'm_id': ___m_id, 'theme': ___theme };
		return await this.return_server_response('digitalmenus', 'set_theme', ___to_post);
	}

//#endregion

//#region 																							D I S H E S

	async dishes___read_single(___dish_id: string) : Promise<type___api___response>
	{
		const ___to_post: any = { 'dish_id': ___dish_id };
		return await this.return_server_response('dishes', 'read_single', ___to_post);
	}

	async dishes___submit(___d_digitalmenu: string, ___d_id: string | null, ___d_category: string, ___d_name: string, ___d_description: string, ___d_price: number, ___d_price_currency: type___digitalmenu___currency, ___d_measurement_unit: type___digitalmenu___dish_measurement_unit, ___d_allergens: string[], ___d_attributes: string[]) : Promise<type___api___response>
	{
		const ___to_post: any = { 'd_digitalmenu': ___d_digitalmenu, 'd_id': ___d_id, 'd_category': ___d_category, 'd_name': ___d_name, 'd_description': ___d_description, 'd_price': ___d_price, 'd_price_currency': ___d_price_currency, 'd_measurement_unit': ___d_measurement_unit, 'd_allergens': ___d_allergens, 'd_attributes': ___d_attributes };
		return await this.return_server_response('dishes', 'submit', ___to_post);
	}

	async dishes___activate(___d_digitalmenu: string, ___d_id: string, ___d_new_active: boolean) : Promise<type___api___response>
	{
		const ___to_post: any = { 'd_digitalmenu': ___d_digitalmenu, 'd_dish': ___d_id, 'd_new_active': ___d_new_active };
		return await this.return_server_response('dishes', 'activate', ___to_post);
	}

	async dishes___delete(___d_digitalmenu: string, ___d_id: string) : Promise<type___api___response>
	{
		const ___to_post: any = { 'd_digitalmenu': ___d_digitalmenu, 'd_dish': ___d_id };
		return await this.return_server_response('dishes', 'delete', ___to_post);
	}

//#endregion

//#region 																							D I S H E S   A L L E R G E N S

	async dishes_allergens___read_multi(___order: 'standard' | 'alphabetical' = 'standard') : Promise<type___api___response>
	{
		const ___to_post: any = { 'order': ___order };
		return await this.return_server_response('dishes_allergens', 'read_multi', ___to_post);
	}

//#endregion

//#region 																							D I S H E S   A T T R I B U T E S

	async dishes_attributes___read_multi() : Promise<type___api___response>
	{
		const ___to_post: any = { };
		return await this.return_server_response('dishes_attributes', 'read_multi', ___to_post);
	}

//#endregion

//#region 																							D I S H E S   C A T E G O R I E S

	async dishes_categories___read_multi(___order: 'standard' | 'alphabetical' = 'standard') : Promise<type___api___response>
	{
		const ___to_post: any = { 'order': ___order };
		return await this.return_server_response('dishes_categories', 'read_multi', ___to_post);
	}

	async dishes_categories___read_single(___dish_category_id: string) : Promise<type___api___response>
	{
		const ___to_post: any = { 'dish_category_id': ___dish_category_id };
		return await this.return_server_response('dishes_categories', 'read_single', ___to_post);
	}

//#endregion

//#region 																							U S E R S

	async users___read_single(___search_target: 'username' | 'id' | 'me', ___search_param: string | null = null) : Promise<type___api___response>
	{
		const ___to_post: any = { 'search_target': ___search_target, 'search_param': ___search_param };
		return await this.return_server_response('users', 'read_single', ___to_post);
	}

//#endregion

}